import { InjectionToken, Provider } from '@angular/core';

export interface IEditabledConfig {
  debounceTimeMs: number;
}

export const EDITABLED_CONFIG = new InjectionToken<IEditabledConfig>('editabled_config');

export const DEFAULT_EDITABLED_CONFIG: IEditabledConfig = {
  debounceTimeMs: 1000,
};

export const provideEditabled = (config: Partial<IEditabledConfig> = {}): Provider => ({
  provide: EDITABLED_CONFIG,
  useValue: { ...DEFAULT_EDITABLED_CONFIG, ...config },
});
